import {
  noticeSeverityCriticalColorPalette,
  noticeSeverityDefaultColorPalette,
  noticeSeverityInfoColorPalette,
  noticeSeverityMajorColorPalette
} from "../theme/colors";
import {noticeSeverity, NoticeSeverity} from "@ots-frontend/ots-data";

export const getNoticeSeverityColorRef = (
  value: NoticeSeverity
): string => {
  switch (value) {
    case noticeSeverity.info:
      return "notice-severity-info";
    case noticeSeverity.major:
      return "notice-severity-major";
    case noticeSeverity.critical:
      return "notice-severity-critical";
    default:
      return "notice-severity-default";
  }
};

export const getNoticeSeverityColor = (
  value: NoticeSeverity
): string => {
  switch (value) {
    case noticeSeverity.info:
      return noticeSeverityInfoColorPalette.primary;
    case noticeSeverity.major:
      return noticeSeverityMajorColorPalette.primary;
    case noticeSeverity.critical:
      return noticeSeverityCriticalColorPalette.primary;
    default:
      return noticeSeverityDefaultColorPalette.primary;
  }
};
